
import { BingMaps, OSM, TileImage, Vector as VectorSource } from 'ol/source';
import View from 'ol/View';
import { Tile, VectorImage } from 'ol/layer';
import Map from 'ol/Map';
import BaseLayer from 'ol/layer/Base';
import booleanIntersects from '@turf/boolean-intersects';
import { Geometry } from 'ol/geom';
import { GeoJSON } from 'ol/format';
import { Feature } from 'ol';

export function buildBingMapsLayer(){
    const baseUrlAzureMaps = 'https://atlas.microsoft.com/map/tile?zoom={z}&x={x}&y={y}&tileSize=256&language=EN&&api-version=2.0';
    const azureMapsKey = 'DLDD4va4q2o9Clg88KFfcbN9MTzXBH4qtoDeJ6LZhbwmYWBXypMIJQQJ99BGACYeBjF4RV88AAAgAZMP42qW';
    const layer = new Tile({
        source: new TileImage({
            url: `${baseUrlAzureMaps}&subscription-key=${azureMapsKey}&tilesetId=microsoft.imagery`,
            attributions: `© ${new Date().getFullYear()} TomTom, Microsoft`,
            crossOrigin: '*',
        }),
    });
    return layer;
}

export function buildOSMMapLayer() {
    return new Tile({ source: new OSM() });
}

export function buildMap(dom: HTMLElement, layers: BaseLayer[]){
    const map = new Map({
        target: dom,
        layers: layers,
        view: new View({
            center: [0, 0],
            zoom: 2,
            projection: 'EPSG:3857'
        }),
    });

    return map;
}

export function buildVectorLayer(){
    return new VectorImage({
        source: new VectorSource()
    });
}

export function intersectFeatures(geometry: Geometry, features: Feature[]) {
    const geojsonFormat = new GeoJSON();
    const turfPolygon = geojsonFormat.writeFeatureObject(new Feature({ geometry: geometry}));
    const featuresIntersection: Feature[] = [];

    for (let feature of features){
        const turfGeometry = geojsonFormat.writeFeatureObject(feature);

        if (booleanIntersects(turfGeometry, turfPolygon)){
            featuresIntersection.push(feature);
        }
    }
    return featuresIntersection;
}

export function zoomIn(map?: Map){
    zoom(1, map);
}

export function zoomOut(map?: Map){
    zoom(-1, map);
}

function zoom(valueToAdd: number, map?: Map){
    if (!map || !map.getView()){
        return;
    }

    const view = map.getView()!;
    const zoom = view.getZoom() ?? 0;
    view.animate({
        duration: 300,
        zoom: zoom + valueToAdd
    });
}

export function fit(vectorLayer?: VectorImage<VectorSource>, map?: Map){
    if (!map || !map.getView() || !vectorLayer || !vectorLayer.getSource()){
        return;
    }

    const view = map.getView()!;
    const source = vectorLayer.getSource()!;

    view.fit(source.getExtent(), {
        duration: 1000,
        maxZoom: 10
    });
}